import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/social-twitter.svg';

export const IconSocialTwitter: IconComponent = props => <Icon {...props} src={src} />;
